import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-group col-12 col-sm-6" }
const _hoisted_16 = { for: "name" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "form-group col-sm-6" }
const _hoisted_19 = { for: "type" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_21 = { value: "1" }
const _hoisted_22 = { value: "2" }
const _hoisted_23 = { class: "form-row" }
const _hoisted_24 = { class: "form-group col-sm-6" }
const _hoisted_25 = { for: "origin" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_27 = { value: "1" }
const _hoisted_28 = { value: "2" }
const _hoisted_29 = { value: "3" }
const _hoisted_30 = { value: "4" }
const _hoisted_31 = { value: "5" }
const _hoisted_32 = { class: "form-group col-12 col-sm-6" }
const _hoisted_33 = { for: "device_type" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Mobile", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Desktop", -1)
const _hoisted_38 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "form-row" }
const _hoisted_40 = { class: "form-group col-12 col-sm-6" }
const _hoisted_41 = { for: "ip" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { class: "form-group col-12 col-sm-6" }
const _hoisted_44 = { for: "price" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "form-row" }
const _hoisted_47 = { class: "form-group col-5" }
const _hoisted_48 = {
  class: "form-group col-2",
  style: {"text-align":"center"}
}
const _hoisted_49 = { class: "form-group col-5" }
const _hoisted_50 = { class: "card-tools" }
const _hoisted_51 = { class: "card-tools" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-excel" }, null, -1)
const _hoisted_55 = { class: "card-body table-body" }

export function render(_ctx, _cache) {
  const _component_download_excel = _resolveComponent("download-excel")
  const _component_table_lite = _resolveComponent("table-lite")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.loginHistory")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.loginHistory")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filterLoginHistory.name) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterLoginHistory.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("labels.entity.type")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "type",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterLoginHistory.type) = $event)),
                    style: {"width":"auto","max-width":"-webkit-fill-available"},
                    class: "form-control"
                  }, [
                    _hoisted_20,
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('labels.login_history.type.email')), 1),
                    _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t('labels.login_history.type.OAuth')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.filterLoginHistory.type]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("labels.entity.origin")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "origin",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filterLoginHistory.origin) = $event)),
                    style: {"width":"auto","max-width":"-webkit-fill-available"},
                    class: "form-control"
                  }, [
                    _hoisted_26,
                    _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('labels.login_history.origin.gmail')), 1),
                    _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t('labels.login_history.origin.facebook')), 1),
                    _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('labels.login_history.origin.twitter')), 1),
                    _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t('labels.login_history.origin.instagram')), 1),
                    _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('labels.login_history.origin.apple')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.filterLoginHistory.origin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("labels.entity.device_type")), 1),
                  _hoisted_34,
                  _withDirectives(_createElementVNode("select", {
                    id: "device_type",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filterLoginHistory.device_type) = $event)),
                    style: {"width":"auto","max-width":"-webkit-fill-available"},
                    class: "form-control"
                  }, _hoisted_38, 512), [
                    [_vModelSelect, _ctx.filterLoginHistory.device_type]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("labels.entity.ip")), 1),
                  _hoisted_42,
                  _withDirectives(_createElementVNode("input", {
                    id: "ip",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.filterLoginHistory.ip) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterLoginHistory.ip]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("labels.entity.date")), 1),
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("input", {
                        id: "dateIni",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.filterLoginHistory.dateIni) = $event)),
                        type: "text",
                        class: "form-control",
                        "data-maska": "##/##/####",
                        placeholder: "dd/mm/yyyy"
                      }, null, 512), [
                        [_vModelText, _ctx.filterLoginHistory.dateIni],
                        [_directive_maska]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("labels.to")), 1),
                    _createElementVNode("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("input", {
                        id: "dateIni",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.filterLoginHistory.dateEnd) = $event)),
                        type: "text",
                        class: "form-control",
                        "data-maska": "##/##/####",
                        placeholder: "dd/mm/yyyy"
                      }, null, 512), [
                        [_vModelText, _ctx.filterLoginHistory.dateEnd],
                        [_directive_maska]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-info",
                  onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                }, _toDisplayString(_ctx.$t('labels.search')), 1),
                _createTextVNode("   "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-default",
                  onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.clear && _ctx.clear(...args)))
                }, _toDisplayString(_ctx.$t('labels.buttons.clean')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                "data-tooltip": "Atualizar"
              }, _hoisted_53),
              _createTextVNode("   "),
              _createVNode(_component_download_excel, {
                fields: _ctx.listaExcelFields,
                fetch: _ctx.gerarExcel,
                type: "xls",
                worksheet: "Login History",
                name: "tlpv-login-history.xls",
                class: "btn btn-sm btn-primary btn-novo",
                style: {"width":"33px"},
                "data-tooltip": "Exportar Excel"
              }, {
                default: _withCtx(() => [
                  _hoisted_54
                ]),
                _: 1
              }, 8, ["fields", "fetch"])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[10] || (_cache[10] = $event => (_ctx.table.isLoading = false))
            }, {
              "user.name": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.user ? props.value.user.name : '-'), 1)
              ]),
              origin: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
                'bg-success': props.value.origin === 1,
                'bg-primary': props.value.origin === 2,
                'bg-warning': props.value.origin === 3,
                'bg-danger': props.value.origin === 4,
                'bg-light': props.value.origin === 5
              }])
                }, _toDisplayString(props.value.origin === 1 ? _ctx.$t('labels.login_history.origin.gmail') : '') + " " + _toDisplayString(props.value.origin === 2 ? _ctx.$t('labels.login_history.origin.facebook') : '') + " " + _toDisplayString(props.value.origin === 3 ? _ctx.$t('labels.login_history.origin.twitter') : '') + " " + _toDisplayString(props.value.origin === 4 ? _ctx.$t('labels.login_history.origin.instagram') : '') + " " + _toDisplayString(props.value.origin === 5 ? _ctx.$t('labels.login_history.origin.apple') : ''), 3)
              ]),
              type: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
                'bg-success': props.value.type === 1,
                'bg-warning': props.value.type === 2
              }])
                }, _toDisplayString(props.value.type === 1 ? _ctx.$t('labels.login_history.type.email') : _ctx.$t('labels.login_history.type.OAuth')), 3)
              ]),
              device_type: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
                'bg-success': props.value.device_type === 1,
                'bg-warning': props.value.device_type === 2
              }])
                }, _toDisplayString(props.value.device_type === 1 ? "Mobile" : props.value.device_type === 2 ? "Desktop" : "-"), 3)
              ]),
              date: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.date ? _ctx.formatDate(props.value.date) : '-'), 1)
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}